import { render, staticRenderFns } from "./assignGamePermission.vue?vue&type=template&id=27f4c3c4"
import script from "./assignGamePermission.vue?vue&type=script&lang=js"
export * from "./assignGamePermission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports